import React, { useEffect } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";

// Custom Components
import Header from "../common/header";
import Footer from "../common/footer";
import { useSelector } from "react-redux";

function Layout() {
  const navigate = useNavigate();
  const isSessionActive = useSelector((state) => state.user.isSessionActive);

  useEffect(() => {
    if (!isSessionActive) navigate("/login");
  }, [isSessionActive]);

  const location = useLocation();
  useEffect(() => {
    let currentTitle = (location.pathname || "/").split("/")[1];
    document.title =
      "Internal Admin - " +
      currentTitle.charAt(0).toUpperCase() +
      currentTitle.slice(1);
  }, [location.pathname]);

  return (
    <div className="grid grid-rows-[auto_1fr_auto] w-full bg-gray-100 min-h-full">
      <Header />
      <Outlet />
      <Footer />
    </div>
  );
}

export default Layout;
